export class HAfExtra {
    id:number
 
    // Yechidot:number=1;
    hafmonth:number;
    // FirstAmount:number=1;
    // totalloan:number=240000
    Num:number;
    // numofheczers:number=300;
}
